import { type ShipmentOrdersListExEntity } from '@/libs/api'
import { SHIPMENT_DELIVERY_STATUS_TYPE } from '@/libs/api/types'

/**
 * VOC_PJ-445 #1864: 選択した依頼を物理削除できるか（削除可否の単一述語）。
 *
 * - 1件以上の選択であること
 * - 配車済みの依頼が混ざっていないこと。配車済みのまま消すと、中身のない矢羽根が配車板に
 *   残るため、BE も同じ条件で 400 を返す。先に「配送依頼に戻す」操作をしてもらう
 * - キャンセル（CANCELLED）の依頼が混ざっていないこと。キャンセルは配送完了と同じく実績と
 *   して残す扱いで、消せる対象ではない
 *
 * 取消済み（REVOKED）は削除できる。取消は「依頼を残したまま無効にする」操作で、
 * 物理削除の対象から外す理由がないため。
 */
export const canDeleteOrders = (
  orders: Pick<
    ShipmentOrdersListExEntity,
    'dispatchDetails' | 'deliveryStatus'
  >[]
): boolean =>
  orders.length > 0 &&
  orders.every(
    (order) =>
      order.dispatchDetails.length === 0 &&
      order.deliveryStatus !== SHIPMENT_DELIVERY_STATUS_TYPE.CANCELLED
  )
